module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.service) ? _c('div', {
    staticClass: "modal animated is-active"
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card",
    staticStyle: {
      "width": "1200px"
    }
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v("Booking/Service #" + _vm._s(_vm.service.booking_id) + "/" + _vm._s(_vm.service.service_id))])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [(_vm.error) ? _c('div', {
    staticClass: "notification is-danger"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-6"
  }, [_c('div', {
    staticClass: "panel panel-info"
  }, [_c('p', {
    staticClass: "panel-heading panel-heading-info"
  }, [_vm._v("Hotel")]), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_c('i', {
    staticClass: "fa fa-bed"
  }), _vm._v(" " + _vm._s(_vm.service.room.hotel.name))]), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_c('i', {
    staticClass: "fa fa-th-list"
  }), _vm._v("\n                " + _vm._s(_vm.service.room.description.substring(0, 45)) + "\n                "), (_vm.service.room.description.length > 45) ? [_c('tooltip', {
    staticStyle: {
      "word-break": "break-all"
    },
    attrs: {
      "label": _vm.service.room.description,
      "type": "default",
      "placement": "right"
    }
  }, [_c('a', {
    staticClass: "is-small"
  }, [_c('i', {
    staticClass: "fa fa-eye"
  })])])] : _vm._e()], 2), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_c('i', {
    staticClass: "fa fa-cutlery"
  }), _vm._v(" " + _vm._s(_vm.service.room.board_description) + " ")]), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm._f("moment")(_vm.service.service_date, 'YYYY-MM-DD')))]), _vm._v(" to "), _c('b', [_vm._v(_vm._s(_vm._f("moment")(_vm.service.service_date, 'add', _vm.service.room.number_nights + ' days', 'YYYY-MM-DD')))])]), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" " + _vm._s(_vm.service.paxes.length))]), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_c('i', {
    staticClass: "fa fa-group"
  }), _vm._v(" Adults: "), _c('b', [_vm._v(_vm._s(_vm.service.room.number_adults))]), _vm._v(" Childrens: "), _c('b', [_vm._v(_vm._s(_vm.service.room.number_children))])]), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_c('i', {
    staticClass: "fa fa-moon-o"
  }), _vm._v(" " + _vm._s(_vm.service.room.number_nights))]), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_c('i', {
    staticClass: "fa fa-usd"
  }), _vm._v(" Net: "), _c('b', [_vm._v(_vm._s(_vm.service.price + " " + _vm.service.currency))]), _vm._v(" Provider: "), _c('b', [_vm._v(_vm._s(_vm.service.room.provider_price + " " + _vm.service.room.provider_currency))])]), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_c('i', {
    staticClass: "fa fa-globe"
  }), _vm._v(" " + _vm._s(_vm.service.room.hotel.city.name))]), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v(" " + _vm._s(_vm.service.room.hotel.address))]), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_c('i', {
    staticClass: "fa fa-phone"
  }), _vm._v(" " + _vm._s(_vm.service.room.hotel.phone))]), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_c('i', {
    staticClass: "fa fa-building-o"
  }), _vm._v(" " + _vm._s(_vm.service.room.provider.name))])]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('p', {
    staticClass: "panel-heading"
  }, [_vm._v("Cancellation")]), _vm._v(" "), _vm._l((_vm.service.room.cancellation), function(cancellation) {
    return _c('p', {
      staticClass: "panel-block"
    }, [_c('i', {
      staticClass: "fa fa-ban"
    }), _vm._v(" "), _c('b', [_vm._v("From: ")]), _vm._v(" " + _vm._s(_vm._f("moment")(cancellation.start_date, 'YYYY-MM-DD hh:mm A')) + " "), _c('b', [_vm._v("To: ")]), _vm._v(_vm._s(_vm._f("moment")(cancellation.end_date, 'YYYY-MM-DD hh:mm A')) + " "), _c('b', [_vm._v("Value: "), _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(" " + _vm._s(parseFloat(cancellation.price).toFixed(2)) + " " + _vm._s(cancellation.currency))])]), _vm._v(" - "), _c('b', [_vm._v(_vm._s(parseInt(cancellation.type) === 1 ? 'Provider' : 'Operator'))])])
  })], 2), _vm._v(" "), (_vm.service.observation && _vm.service.observation !== '') ? [_c('div', {
    staticClass: "panel panel-info"
  }, [_c('p', {
    staticClass: "panel-heading panel-heading-info"
  }, [_vm._v("Observation")]), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_c('pre', [_vm._v(_vm._s(_vm.service.observation))])])])] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "column is-6"
  }, [(_vm.change) ? [_c('div', {
    staticClass: "panel panel-info"
  }, [_c('p', {
    staticClass: "panel-heading panel-heading-info"
  }, [_vm._v("Hotel")]), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_c('i', {
    staticClass: "fa fa-bed"
  }), _vm._v(" " + _vm._s(_vm.change.SelectedHotel.HotelInfo.HotelName) + " "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.checkDiff(_vm.service.room.hotel.name, _vm.change.SelectedHotel.HotelInfo.HotelName, true, true))
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_c('i', {
    staticClass: "fa fa-th-list"
  }), _vm._v("\n                  " + _vm._s(_vm.change.SelectedHotel.Rooms.RoomResultCancellationPolicies_g.RoomDescription.substring(0, 45)) + "\n                  "), (_vm.change.SelectedHotel.Rooms.RoomResultCancellationPolicies_g.RoomDescription > 45) ? [_c('tooltip', {
    staticStyle: {
      "word-break": "break-all"
    },
    attrs: {
      "label": _vm.change.SelectedHotel.Rooms.RoomResultCancellationPolicies_g.RoomDescription,
      "type": "default",
      "placement": "right"
    }
  }, [_c('a', {
    staticClass: "is-small"
  }, [_c('i', {
    staticClass: "fa fa-eye"
  })])])] : _vm._e(), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.checkDiff(_vm.service.room.description, _vm.change.SelectedHotel.Rooms.RoomResultCancellationPolicies_g.RoomDescription, true, true))
    }
  })], 2), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_c('i', {
    staticClass: "fa fa-cutlery"
  }), _vm._v(" " + _vm._s(_vm.change.SelectedHotel.Rooms.RoomResultCancellationPolicies_g.BoardDescription) + " "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.checkDiff(_vm.service.room.board_description, _vm.change.SelectedHotel.Rooms.RoomResultCancellationPolicies_g.BoardDescription, true, true))
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm._f("moment")(_vm.change.SelectedHotel.CheckInDate, 'YYYY-MM-DD')))]), _vm._v(" to "), _c('b', [_vm._v(_vm._s(_vm._f("moment")(_vm.change.SelectedHotel.CheckInDate, 'add', _vm.change.SelectedHotel.NumberOfNights + ' days', 'YYYY-MM-DD')))]), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.checkDiff(_vm.parseDate(_vm.service.service_date), _vm.parseDate(_vm.change.SelectedHotel.CheckInDate)))
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" " + _vm._s(parseInt(_vm.change.SelectedHotel.Rooms.RoomResultCancellationPolicies_g.QtyAdults) + parseInt(_vm.parseChildrens(_vm.change.SelectedHotel.Rooms.RoomResultCancellationPolicies_g.AgeOfTheChildren))))]), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_c('i', {
    staticClass: "fa fa-group"
  }), _vm._v(" Adults: "), _c('b', [_vm._v(_vm._s(_vm.change.SelectedHotel.Rooms.RoomResultCancellationPolicies_g.QtyAdults))]), _vm._v(" Childrens: "), _c('b', [_vm._v(_vm._s(_vm.parseChildrens(_vm.change.SelectedHotel.Rooms.RoomResultCancellationPolicies_g.AgeOfTheChildren)))])]), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_c('i', {
    staticClass: "fa fa-moon-o"
  }), _vm._v(" " + _vm._s(_vm.change.SelectedHotel.NumberOfNights))]), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_c('i', {
    staticClass: "fa fa-usd"
  }), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.change.SelectedHotel.Rooms.RoomResultCancellationPolicies_g.SellPriceTotal.Value + " " + _vm.change.SelectedHotel.Rooms.RoomResultCancellationPolicies_g.SellPriceTotal.Currency))]), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.checkDiff(_vm.service.room.provider_price, _vm.change.SelectedHotel.Rooms.RoomResultCancellationPolicies_g.SellPriceTotal.Value))
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_c('i', {
    staticClass: "fa fa-globe"
  }), _vm._v(" " + _vm._s(_vm.change.SelectedHotel.HotelInfo.CityName) + " "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.checkDiff(_vm.service.room.hotel.city.name, _vm.change.SelectedHotel.HotelInfo.CityName, false, true))
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v(" " + _vm._s(_vm.change.SelectedHotel.HotelInfo.Address) + " "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.checkDiff(_vm.service.room.hotel.address, _vm.change.SelectedHotel.HotelInfo.Address, true, true))
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_c('i', {
    staticClass: "fa fa-building-o"
  }), _vm._v(" " + _vm._s(this.supplier) + " "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.checkDiff(_vm.service.room.provider.name, this.supplier, true, true))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('p', {
    staticClass: "panel-heading"
  }, [_vm._v("Cancellation")]), _vm._v(" "), _vm._l((_vm.parseCancellation()), function(cancellation) {
    return [_c('p', {
      staticClass: "panel-block"
    }, [_c('i', {
      staticClass: "fa fa-ban"
    }), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(cancellation)
      }
    })])]
  })], 2)] : [(_vm.error) ? [_vm._m(0)] : [_vm._m(1)]]], 2)])])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('div', {
    staticClass: "control is-grouped is-pulled-right"
  }, [_c('p', {
    staticClass: "control is-pulled-right"
  }, [_c('a', {
    staticClass: "button is-primary",
    class: {
      'is-disabled': _vm.inProgress
    },
    on: {
      "click": function($event) {
        return _vm.close(false)
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('a', {
    staticClass: "button is-success",
    class: {
      'is-disabled': _vm.inProgress || _vm.change === null,
      'is-loading': _vm.inProgress
    },
    on: {
      "click": function($event) {
        return _vm.next()
      }
    }
  }, [_vm._v("Change")])])])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticClass: "panel-block",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    staticStyle: {
      "font-size": "150px"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticClass: "panel-block",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin fa-3x fa-fw",
    staticStyle: {
      "font-size": "150px"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65df976c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/bi/ChangeConfirm.vue
// module id = 1145
// module chunks = 39